import { IModel, IViolation, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Owned } from 'app/model/base/named';
import { copyMethodOptionValues } from 'app/shared/components/copy-method-setting/copy-method-setting.const';
import { dwSinkDisAllowedPolybase } from 'app/shared/utils/copy-method.util';

@Metamodel.model({
    display: [stringResources.PolybaseSetting_Polybase_Label]
})
export class PolybaseSetting extends Owned {
    public static readonly MODEL: IModel;
    public static readonly REJECT_VALUE: IAttribute;
    public static readonly REJECT_SAMPLE_VALUE: IAttribute;
    public static readonly USE_TYPE_DEFAULT: IAttribute;

    public rejectType?: string = 'value';
    @Metamodel.attribute({
        display: stringResources.PolybaseSetting_RejectValue_Label,
        constraint: {
            required: ['rejectType'],
            minimum: 0,
            validator: PolybaseSetting.validateRejectValue
        },
        association: 'REJECT_VALUE',
        templatable: true
    })
    public rejectValue?: number = 0;
    @Metamodel.attribute({
        display: stringResources.PolybaseSetting_RejectSampleValue_Label,
        constraint: {
            whole: true,
            minimum: 0,
            validator: PolybaseSetting.validateRejectSampleValue
        },
        association: 'REJECT_SAMPLE_VALUE',
        templatable: true
    })
    public rejectSampleValue?: number;
    @Metamodel.attribute({
        association: 'USE_TYPE_DEFAULT',
        templatable: true
    })
    public useTypeDefault?: boolean = true;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validateRejectValue(owner: any, value: any): IViolation[] | undefined {
        if ((owner.owner).copyMethod === copyMethodOptionValues.PolyBase
            && !dwSinkDisAllowedPolybase(owner.owner)) {
            if (owner && owner.rejectType === 'percentage') {
                if (owner.rejectSampleValue != null && value != null && (Number.isNaN(value) || value > 100 || value < 0)) {
                    return [{
                        context: owner,
                        message: () => stringResources.PolybaseSetting_Error_RejectValueRange
                    }];
                }
            } else if (owner && owner.rejectType === 'value') {
                if (value != null && !Number.isInteger(value)) {
                    return [{
                        context: owner,
                        message: () => stringResources.PolybaseSetting_Error_RejectValueWhole
                    }];
                }
            }
        }

        return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validateRejectSampleValue(owner: any, value: any): IViolation[] | undefined {
        if ((owner.owner).copyMethod === copyMethodOptionValues.PolyBase
            && !dwSinkDisAllowedPolybase(owner.owner)) {
            if (owner && owner.rejectType === 'percentage' && value == null) {
                return [{
                    context: owner,
                    message: () => stringResources.PolybaseSetting_Error_RejectSampleValueRequired
                }];
            }
        }
        return undefined;
    }
}
